<template>
  <v-app class="app-shell">
    <div class="app-main">
      <router-view name="NavBarDashboard"/>
      <router-view name="NavBarEmpresa"/>
      <router-view name="NavBar"/>
      <router-view name="sideMenuDashboard"/>
      <router-view/>
    </div>
    <FooterBar />
  </v-app>
</template>

<script>
import FooterBar from '@/components/FooterBar.vue'
// import NavBar from '@/components/NavBar.vue'
// import NavBarEmpresa from './components/NavBarEmpresa.vue';
// import NavBarDashboard from './components/NavBarDashboard.vue';

export default {
  inheritAttrs:false,
  
  components: { FooterBar }
}
</script>

<style>
:root {
  --color-icon-active: #111827;
  --color-icon-inactive: #9ca3af;
  --color-title: #0a222b;
  --color-text: #0a222b;
  --color-primary: #088395;
  --color-primary-contrast: #ffffff;
  --color-bg: #ffffff;
  --color-surface: #ffffff;
  --color-border: #e5e7eb;
  --color-muted: #6b7a80;
  --color-table-header-bg: var(--color-primary);
  --color-table-header-text: var(--color-primary-contrast);
  --font-title-family: 'Roboto, sans-serif';
  --font-text-family: 'Roboto, sans-serif';
  --font-title-size: 20px;
  --font-text-size: 16px;
  --font-muted-size: 12px;
}

body {
  background: var(--color-bg);
  color: var(--color-text);
  font-family: var(--font-text-family);
  font-size: var(--font-text-size);
}

[data-help-icons="off"] .help-icon {
  display: none !important;
}

a {
  color: var(--color-primary);
}

a:hover {
  color: var(--color-primary);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--color-title);
  font-family: var(--font-title-family);
}

h1 { font-size: calc(var(--font-title-size) + 6px); }
h2 { font-size: var(--font-title-size); }
h3 { font-size: calc(var(--font-title-size) - 2px); }
.hint, .helper, .small-muted {
  font-size: var(--font-muted-size);
}

table thead th {
  background-color: var(--color-table-header-bg);
  color: var(--color-table-header-text);
}

</style>

<style scoped>
#app {
  font-family: var(--font-text-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-text);
}
.app-shell{ min-height: 100vh; display:flex; flex-direction: column; background: var(--color-bg); color: var(--color-text); }
.app-main{ flex: 1 0 auto; padding-top: 80px; }
</style>



